import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Col = styled(Col)`
  [class*='RadioCardContainer'] {
    border-radius: ${({ theme }) => theme.tw.radius.lg};
  }
`;

export const $PlaceholderPosition = styled.div`
  p {
    margin: 0;
    padding: ${spacing('xxs')};
  }
`;
